const timeZone = [
  {
    label: "Africa/Abidjan",
    value: "Africa/Abidjan"
  },
  {
    label: "Africa/Accra",
    value: "Africa/Accra"
  },
  {
    label: "Africa/Addis_Ababa",
    value: "Africa/Addis_Ababa"
  },
  {
    label: "Africa/Algiers",
    value: "Africa/Algiers"
  },
  {
    label: "Africa/Asmara",
    value: "Africa/Asmara"
  },
  {
    label: "Africa/Asmera",
    value: "Africa/Asmera"
  },
  {
    label: "Africa/Bamako",
    value: "Africa/Bamako"
  },
  {
    label: "Africa/Bangui",
    value: "Africa/Bangui"
  },
  {
    label: "Africa/Banjul",
    value: "Africa/Banjul"
  },
  {
    label: "Africa/Bissau",
    value: "Africa/Bissau"
  },
  {
    label: "Africa/Blantyre",
    value: "Africa/Blantyre"
  },
  {
    label: "Africa/Brazzaville",
    value: "Africa/Brazzaville"
  },
  {
    label: "Africa/Bujumbura",
    value: "Africa/Bujumbura"
  },
  {
    label: "Africa/Cairo",
    value: "Africa/Cairo"
  },
  {
    label: "Africa/Casablanca",
    value: "Africa/Casablanca"
  },
  {
    label: "Africa/Ceuta",
    value: "Africa/Ceuta"
  },
  {
    label: "Africa/Conakry",
    value: "Africa/Conakry"
  },
  {
    label: "Africa/Dakar",
    value: "Africa/Dakar"
  },
  {
    label: "Africa/Dar_es_Salaam",
    value: "Africa/Dar_es_Salaam"
  },
  {
    label: "Africa/Djibouti",
    value: "Africa/Djibouti"
  },
  {
    label: "Africa/Douala",
    value: "Africa/Douala"
  },
  {
    label: "Africa/El_Aaiun",
    value: "Africa/El_Aaiun"
  },
  {
    label: "Africa/Freetown",
    value: "Africa/Freetown"
  },
  {
    label: "Africa/Gaborone",
    value: "Africa/Gaborone"
  },
  {
    label: "Africa/Harare",
    value: "Africa/Harare"
  },
  {
    label: "Africa/Johannesburg",
    value: "Africa/Johannesburg"
  },
  {
    label: "Africa/Juba",
    value: "Africa/Juba"
  },
  {
    label: "Africa/Kampala",
    value: "Africa/Kampala"
  },
  {
    label: "Africa/Khartoum",
    value: "Africa/Khartoum"
  },
  {
    label: "Africa/Kigali",
    value: "Africa/Kigali"
  },
  {
    label: "Africa/Kinshasa",
    value: "Africa/Kinshasa"
  },
  {
    label: "Africa/Lagos",
    value: "Africa/Lagos"
  },
  {
    label: "Africa/Libreville",
    value: "Africa/Libreville"
  },
  {
    label: "Africa/Lome",
    value: "Africa/Lome"
  },
  {
    label: "Africa/Luanda",
    value: "Africa/Luanda"
  },
  {
    label: "Africa/Lubumbashi",
    value: "Africa/Lubumbashi"
  },
  {
    label: "Africa/Lusaka",
    value: "Africa/Lusaka"
  },
  {
    label: "Africa/Malabo",
    value: "Africa/Malabo"
  },
  {
    label: "Africa/Maputo",
    value: "Africa/Maputo"
  },
  {
    label: "Africa/Maseru",
    value: "Africa/Maseru"
  },
  {
    label: "Africa/Mbabane",
    value: "Africa/Mbabane"
  },
  {
    label: "Africa/Mogadishu",
    value: "Africa/Mogadishu"
  },
  {
    label: "Africa/Monrovia",
    value: "Africa/Monrovia"
  },
  {
    label: "Africa/Nairobi",
    value: "Africa/Nairobi"
  },
  {
    label: "Africa/Ndjamena",
    value: "Africa/Ndjamena"
  },
  {
    label: "Africa/Niamey",
    value: "Africa/Niamey"
  },
  {
    label: "Africa/Nouakchott",
    value: "Africa/Nouakchott"
  },
  {
    label: "Africa/Ouagadougou",
    value: "Africa/Ouagadougou"
  },
  {
    label: "Africa/Porto-Novo",
    value: "Africa/Porto-Novo"
  },
  {
    label: "Africa/Sao_Tome",
    value: "Africa/Sao_Tome"
  },
  {
    label: "Africa/Timbuktu",
    value: "Africa/Timbuktu"
  },
  {
    label: "Africa/Tripoli",
    value: "Africa/Tripoli"
  },
  {
    label: "Africa/Tunis",
    value: "Africa/Tunis"
  },
  {
    label: "Africa/Windhoek",
    value: "Africa/Windhoek"
  },
  {
    label: "America/Adak",
    value: "America/Adak"
  },
  {
    label: "America/Anchorage",
    value: "America/Anchorage"
  },
  {
    label: "America/Anguilla",
    value: "America/Anguilla"
  },
  {
    label: "America/Antigua",
    value: "America/Antigua"
  },
  {
    label: "America/Araguaina",
    value: "America/Araguaina"
  },
  {
    label: "America/Argentina/Buenos_Aires",
    value: "America/Argentina/Buenos_Aires"
  },
  {
    label: "America/Argentina/Catamarca",
    value: "America/Argentina/Catamarca"
  },
  {
    label: "America/Argentina/ComodRivadavia",
    value: "America/Argentina/ComodRivadavia"
  },
  {
    label: "America/Argentina/Cordoba",
    value: "America/Argentina/Cordoba"
  },
  {
    label: "America/Argentina/Jujuy",
    value: "America/Argentina/Jujuy"
  },
  {
    label: "America/Argentina/La_Rioja",
    value: "America/Argentina/La_Rioja"
  },
  {
    label: "America/Argentina/Mendoza",
    value: "America/Argentina/Mendoza"
  },
  {
    label: "America/Argentina/Rio_Gallegos",
    value: "America/Argentina/Rio_Gallegos"
  },
  {
    label: "America/Argentina/Salta",
    value: "America/Argentina/Salta"
  },
  {
    label: "America/Argentina/San_Juan",
    value: "America/Argentina/San_Juan"
  },
  {
    label: "America/Argentina/San_Luis",
    value: "America/Argentina/San_Luis"
  },
  {
    label: "America/Argentina/Tucuman",
    value: "America/Argentina/Tucuman"
  },
  {
    label: "America/Argentina/Ushuaia",
    value: "America/Argentina/Ushuaia"
  },
  {
    label: "America/Aruba",
    value: "America/Aruba"
  },
  {
    label: "America/Asuncion",
    value: "America/Asuncion"
  },
  {
    label: "America/Atikokan",
    value: "America/Atikokan"
  },
  {
    label: "America/Atka",
    value: "America/Atka"
  },
  {
    label: "America/Bahia",
    value: "America/Bahia"
  },
  {
    label: "America/Bahia_Banderas",
    value: "America/Bahia_Banderas"
  },
  {
    label: "America/Barbados",
    value: "America/Barbados"
  },
  {
    label: "America/Belem",
    value: "America/Belem"
  },
  {
    label: "America/Belize",
    value: "America/Belize"
  },
  {
    label: "America/Blanc-Sablon",
    value: "America/Blanc-Sablon"
  },
  {
    label: "America/Boa_Vista",
    value: "America/Boa_Vista"
  },
  {
    label: "America/Bogota",
    value: "America/Bogota"
  },
  {
    label: "America/Boise",
    value: "America/Boise"
  },
  {
    label: "America/Buenos_Aires",
    value: "America/Buenos_Aires"
  },
  {
    label: "America/Cambridge_Bay",
    value: "America/Cambridge_Bay"
  },
  {
    label: "America/Campo_Grande",
    value: "America/Campo_Grande"
  },
  {
    label: "America/Cancun",
    value: "America/Cancun"
  },
  {
    label: "America/Caracas",
    value: "America/Caracas"
  },
  {
    label: "America/Catamarca",
    value: "America/Catamarca"
  },
  {
    label: "America/Cayenne",
    value: "America/Cayenne"
  },
  {
    label: "America/Cayman",
    value: "America/Cayman"
  },
  {
    label: "America/Chicago",
    value: "America/Chicago"
  },
  {
    label: "America/Chihuahua",
    value: "America/Chihuahua"
  },
  {
    label: "America/Coral_Harbour",
    value: "America/Coral_Harbour"
  },
  {
    label: "America/Cordoba",
    value: "America/Cordoba"
  },
  {
    label: "America/Costa_Rica",
    value: "America/Costa_Rica"
  },
  {
    label: "America/Creston",
    value: "America/Creston"
  },
  {
    label: "America/Cuiaba",
    value: "America/Cuiaba"
  },
  {
    label: "America/Curacao",
    value: "America/Curacao"
  },
  {
    label: "America/Danmarkshavn",
    value: "America/Danmarkshavn"
  },
  {
    label: "America/Dawson",
    value: "America/Dawson"
  },
  {
    label: "America/Dawson_Creek",
    value: "America/Dawson_Creek"
  },
  {
    label: "America/Denver",
    value: "America/Denver"
  },
  {
    label: "America/Detroit",
    value: "America/Detroit"
  },
  {
    label: "America/Dominica",
    value: "America/Dominica"
  },
  {
    label: "America/Edmonton",
    value: "America/Edmonton"
  },
  {
    label: "America/Eirunepe",
    value: "America/Eirunepe"
  },
  {
    label: "America/El_Salvador",
    value: "America/El_Salvador"
  },
  {
    label: "America/Ensenada",
    value: "America/Ensenada"
  },
  {
    label: "America/Fort_Nelson",
    value: "America/Fort_Nelson"
  },
  {
    label: "America/Fort_Wayne",
    value: "America/Fort_Wayne"
  },
  {
    label: "America/Fortaleza",
    value: "America/Fortaleza"
  },
  {
    label: "America/Glace_Bay",
    value: "America/Glace_Bay"
  },
  {
    label: "America/Godthab",
    value: "America/Godthab"
  },
  {
    label: "America/Goose_Bay",
    value: "America/Goose_Bay"
  },
  {
    label: "America/Grand_Turk",
    value: "America/Grand_Turk"
  },
  {
    label: "America/Grenada",
    value: "America/Grenada"
  },
  {
    label: "America/Guadeloupe",
    value: "America/Guadeloupe"
  },
  {
    label: "America/Guatemala",
    value: "America/Guatemala"
  },
  {
    label: "America/Guayaquil",
    value: "America/Guayaquil"
  },
  {
    label: "America/Guyana",
    value: "America/Guyana"
  },
  {
    label: "America/Halifax",
    value: "America/Halifax"
  },
  {
    label: "America/Havana",
    value: "America/Havana"
  },
  {
    label: "America/Hermosillo",
    value: "America/Hermosillo"
  },
  {
    label: "America/Indiana/Indianapolis",
    value: "America/Indiana/Indianapolis"
  },
  {
    label: "America/Indiana/Knox",
    value: "America/Indiana/Knox"
  },
  {
    label: "America/Indiana/Marengo",
    value: "America/Indiana/Marengo"
  },
  {
    label: "America/Indiana/Petersburg",
    value: "America/Indiana/Petersburg"
  },
  {
    label: "America/Indiana/Tell_City",
    value: "America/Indiana/Tell_City"
  },
  {
    label: "America/Indiana/Vevay",
    value: "America/Indiana/Vevay"
  },
  {
    label: "America/Indiana/Vincennes",
    value: "America/Indiana/Vincennes"
  },
  {
    label: "America/Indiana/Winamac",
    value: "America/Indiana/Winamac"
  },
  {
    label: "America/Indianapolis",
    value: "America/Indianapolis"
  },
  {
    label: "America/Inuvik",
    value: "America/Inuvik"
  },
  {
    label: "America/Iqaluit",
    value: "America/Iqaluit"
  },
  {
    label: "America/Jamaica",
    value: "America/Jamaica"
  },
  {
    label: "America/Jujuy",
    value: "America/Jujuy"
  },
  {
    label: "America/Juneau",
    value: "America/Juneau"
  },
  {
    label: "America/Kentucky/Louisville",
    value: "America/Kentucky/Louisville"
  },
  {
    label: "America/Kentucky/Monticello",
    value: "America/Kentucky/Monticello"
  },
  {
    label: " America/Knox_IN",
    value: " America/Knox_IN"
  },
  {
    label: " America/Kralendijk",
    value: " America/Kralendijk"
  },
  {
    label: " America/La_Paz",
    value: " America/La_Paz"
  },
  {
    label: " America/Lima",
    value: " America/Lima"
  },
  {
    label: " America/Los_Angeles",
    value: " America/Los_Angeles"
  },
  {
    label: " America/Louisville",
    value: " America/Louisville"
  },
  {
    label: " America/Lower_Princes",
    value: " America/Lower_Princes"
  },
  {
    label: " America/Maceio",
    value: " America/Maceio"
  },
  {
    label: " America/Managua",
    value: " America/Managua"
  },
  {
    label: " America/Manaus",
    value: " America/Manaus"
  },
  {
    label: " America/Marigot",
    value: " America/Marigot"
  },
  {
    label: " America/Martinique",
    value: " America/Martinique"
  },
  {
    label: " America/Matamoros",
    value: " America/Matamoros"
  },
  {
    label: " America/Mazatlan",
    value: " America/Mazatlan"
  },
  {
    label: " America/Mendoza",
    value: " America/Mendoza"
  },
  {
    label: " America/Menominee",
    value: " America/Menominee"
  },
  {
    label: " America/Merida",
    value: " America/Merida"
  },
  {
    label: " America/Metlakatla",
    value: " America/Metlakatla"
  },
  {
    label: " America/Mexico_City",
    value: " America/Mexico_City"
  },
  {
    label: " America/Miquelon",
    value: " America/Miquelon"
  },
  {
    label: " America/Moncton",
    value: " America/Moncton"
  },
  {
    label: " America/Monterrey",
    value: " America/Monterrey"
  },
  {
    label: " America/Montevideo",
    value: " America/Montevideo"
  },
  {
    label: "America/Montreal",
    value: "America/Montreal"
  },
  {
    label: "America/Montserrat",
    value: "America/Montserrat"
  },
  {
    label: "America/Nassau",
    value: "America/Nassau"
  },
  {
    label: "America/New_York",
    value: "America/New_York"
  },
  {
    label: "America/Nipigon",
    value: "America/Nipigon"
  },
  {
    label: "America/Nome",
    value: "America/Nome"
  },
  {
    label: "America/Noronha",
    value: "America/Noronha"
  },
  {
    label: "America/North_Dakota/Beulah",
    value: "America/North_Dakota/Beulah"
  },
  {
    label: "America/North_Dakota/Center",
    value: "America/North_Dakota/Center"
  },
  {
    label: "America/North_Dakota/New_Salem",
    value: "America/North_Dakota/New_Salem"
  },
  {
    label: "America/Ojinaga",
    value: "America/Ojinaga"
  },
  {
    label: "America/Panama",
    value: "America/Panama"
  },
  {
    label: "America/Pangnirtung",
    value: "America/Pangnirtung"
  },
  {
    label: "America/Paramaribo",
    value: "America/Paramaribo"
  },
  {
    label: "America/Phoenix",
    value: "America/Phoenix"
  },
  {
    label: "America/Port-au-Prince",
    value: "America/Port-au-Prince"
  },
  {
    label: "America/Port_of_Spain",
    value: "America/Port_of_Spain"
  },
  {
    label: "America/Porto_Acre",
    value: "America/Porto_Acre"
  },
  {
    label: "America/Porto_Velho",
    value: "America/Porto_Velho"
  },
  {
    label: "America/Puerto_Rico",
    value: "America/Puerto_Rico"
  },
  {
    label: "America/Punta_Arenas",
    value: "America/Punta_Arenas"
  },
  {
    label: "America/Rainy_River",
    value: "America/Rainy_River"
  },
  {
    label: "America/Rankin_Inlet",
    value: "America/Rankin_Inlet"
  },
  {
    label: "America/Recife",
    value: "America/Recife"
  },
  {
    label: "America/Regina",
    value: "America/Regina"
  },
  {
    label: "America/Resolute",
    value: "America/Resolute"
  },
  {
    label: "America/Rio_Branco",
    value: "America/Rio_Branco"
  },
  {
    label: "America/Rosario",
    value: "America/Rosario"
  },
  {
    label: "America/Santa_Isabel",
    value: "America/Santa_Isabel"
  },
  {
    label: "America/Santarem",
    value: "America/Santarem"
  },
  {
    label: "America/Santiago",
    value: "America/Santiago"
  },
  {
    label: "America/Santo_Domingo",
    value: "America/Santo_Domingo"
  },
  {
    label: "America/Sao_Paulo",
    value: "America/Sao_Paulo"
  },
  {
    label: "America/Scoresbysund",
    value: "America/Scoresbysund"
  },
  {
    label: "America/Shiprock",
    value: "America/Shiprock"
  },
  {
    label: "America/Sitka",
    value: "America/Sitka"
  },
  {
    label: "America/St_Barthelemy",
    value: "America/St_Barthelemy"
  },
  {
    label: "America/St_Johns",
    value: "America/St_Johns"
  },
  {
    label: "America/St_Kitts",
    value: "America/St_Kitts"
  },
  {
    label: "America/St_Lucia",
    value: "America/St_Lucia"
  },
  {
    label: "America/St_Thomas",
    value: "America/St_Thomas"
  },
  {
    label: "America/St_Vincent",
    value: "America/St_Vincent"
  },
  {
    label: "America/Swift_Current",
    value: "America/Swift_Current"
  },
  {
    label: "America/Tegucigalpa",
    value: "America/Tegucigalpa"
  },
  {
    label: "America/Thule",
    value: "America/Thule"
  },
  {
    label: "America/Thunder_Bay",
    value: "America/Thunder_Bay"
  },
  {
    label: "America/Tijuana",
    value: "America/Tijuana"
  },
  {
    label: "America/Toronto",
    value: "America/Toronto"
  },
  {
    label: "America/Tortola",
    value: "America/Tortola"
  },
  {
    label: "America/Vancouver",
    value: "America/Vancouver"
  },
  {
    label: "America/Virgin",
    value: "America/Virgin"
  },
  {
    label: "America/Whitehorse",
    value: "America/Whitehorse"
  },
  {
    label: "America/Winnipeg",
    value: "America/Winnipeg"
  },
  {
    label: "America/Yakutat",
    value: "America/Yakutat"
  },
  {
    label: "America/Yellowknife",
    value: "America/Yellowknife"
  },
  {
    label: "Antarctica/Casey",
    value: "Antarctica/Casey"
  },
  {
    label: "Antarctica/Davis",
    value: "Antarctica/Davis"
  },
  {
    label: "Antarctica/DumontDUrville",
    value: "Antarctica/DumontDUrville"
  },
  {
    label: "Antarctica/Macquarie",
    value: "Antarctica/Macquarie"
  },
  {
    label: "Antarctica/Mawson",
    value: "Antarctica/Mawson"
  },
  {
    label: "Antarctica/McMurdo",
    value: "Antarctica/McMurdo"
  },
  {
    label: "Antarctica/Palmer",
    value: "Antarctica/Palmer"
  },
  {
    label: "Antarctica/Rothera",
    value: "Antarctica/Rothera"
  },
  {
    label: "Antarctica/South_Pole",
    value: "Antarctica/South_Pole"
  },
  {
    label: "Antarctica/Syowa",
    value: "Antarctica/Syowa"
  },
  {
    label: "Antarctica/Troll",
    value: "Antarctica/Troll"
  },
  {
    label: "Antarctica/Vostok",
    value: "Antarctica/Vostok"
  },
  {
    label: "Arctic/Longyearbyen",
    value: "Arctic/Longyearbyen"
  },
  {
    label: "Asia/Aden",
    value: "Asia/Aden"
  },
  {
    label: "Asia/Almaty",
    value: "Asia/Almaty"
  },
  {
    label: "Asia/Amman",
    value: "Asia/Amman"
  },
  {
    label: "Asia/Anadyr",
    value: "Asia/Anadyr"
  },
  {
    label: "Asia/Aqtau",
    value: "Asia/Aqtau"
  },
  {
    label: "Asia/Aqtobe",
    value: "Asia/Aqtobe"
  },
  {
    label: "Asia/Ashgabat",
    value: "Asia/Ashgabat"
  },
  {
    label: "Asia/Ashkhabad",
    value: "Asia/Ashkhabad"
  },
  {
    label: "Asia/Atyrau",
    value: "Asia/Atyrau"
  },
  {
    label: "Asia/Baghdad",
    value: "Asia/Baghdad"
  },
  {
    label: "Asia/Bahrain",
    value: "Asia/Bahrain"
  },
  {
    label: "Asia/Baku",
    value: "Asia/Baku"
  },
  {
    label: "Asia/Bangkok",
    value: "Asia/Bangkok"
  },
  {
    label: "Asia/Barnaul",
    value: "Asia/Barnaul"
  },
  {
    label: "Asia/Beirut",
    value: "Asia/Beirut"
  },
  {
    label: "Asia/Bishkek",
    value: "Asia/Bishkek"
  },
  {
    label: "Asia/Brunei",
    value: "Asia/Brunei"
  },
  {
    label: "Asia/Calcutta",
    value: "Asia/Calcutta"
  },
  {
    label: "Asia/Chita",
    value: "Asia/Chita"
  },
  {
    label: "Asia/Choibalsan",
    value: "Asia/Choibalsan"
  },
  {
    label: "Asia/Chongqing",
    value: "Asia/Chongqing"
  },
  {
    label: "Asia/Chungking",
    value: "Asia/Chungking"
  },
  {
    label: "Asia/Colombo",
    value: "Asia/Colombo"
  },
  {
    label: "Asia/Dacca",
    value: "Asia/Dacca"
  },
  {
    label: "Asia/Damascus",
    value: "Asia/Damascus"
  },
  {
    label: "Asia/Dhaka",
    value: "Asia/Dhaka"
  },
  {
    label: "Asia/Dili",
    value: "Asia/Dili"
  },
  {
    label: "Asia/Dubai",
    value: "Asia/Dubai"
  },
  {
    label: "Asia/Dushanbe",
    value: "Asia/Dushanbe"
  },
  {
    label: "Asia/Famagusta",
    value: "Asia/Famagusta"
  },
  {
    label: "Asia/Gaza",
    value: "Asia/Gaza"
  },
  {
    label: "Asia/Harbin",
    value: "Asia/Harbin"
  },
  {
    label: "Asia/Hebron",
    value: "Asia/Hebron"
  },
  {
    label: "Asia/Ho_Chi_Minh",
    value: "Asia/Ho_Chi_Minh"
  },
  {
    label: "Asia/Hong_Kong",
    value: "Asia/Hong_Kong"
  },
  {
    label: "Asia/Hovd",
    value: "Asia/Hovd"
  },
  {
    label: "Asia/Irkutsk",
    value: "Asia/Irkutsk"
  },
  {
    label: "Asia/Istanbul",
    value: "Asia/Istanbul"
  },
  {
    label: "Asia/Jakarta",
    value: "Asia/Jakarta"
  },
  {
    label: "Asia/Jayapura",
    value: "Asia/Jayapura"
  },
  {
    label: "Asia/Jerusalem",
    value: "Asia/Jerusalem"
  },
  {
    label: "Asia/Kabul",
    value: "Asia/Kabul"
  },
  {
    label: "Asia/Kamchatka",
    value: "Asia/Kamchatka"
  },
  {
    label: "Asia/Karachi",
    value: "Asia/Karachi"
  },
  {
    label: "Asia/Kashgar",
    value: "Asia/Kashgar"
  },
  {
    label: "Asia/Kathmandu",
    value: "Asia/Kathmandu"
  },
  {
    label: "Asia/Katmandu",
    value: "Asia/Katmandu"
  },
  {
    label: "Asia/Khandyga",
    value: "Asia/Khandyga"
  },
  {
    label: "Asia/Kolkata",
    value: "Asia/Kolkata"
  },
  {
    label: "Asia/Krasnoyarsk",
    value: "Asia/Krasnoyarsk"
  },
  {
    label: "Asia/Kuala_Lumpur",
    value: "Asia/Kuala_Lumpur"
  },
  {
    label: "Asia/Kuching",
    value: "Asia/Kuching"
  },
  {
    label: "Asia/Kuwait",
    value: "Asia/Kuwait"
  },
  {
    label: "Asia/Macao",
    value: "Asia/Macao"
  },
  {
    label: "Asia/Macau",
    value: "Asia/Macau"
  },
  {
    label: "Asia/Magadan",
    value: "Asia/Magadan"
  },
  {
    label: "Asia/Makassar",
    value: "Asia/Makassar"
  },
  {
    label: "Asia/Manila",
    value: "Asia/Manila"
  },
  {
    label: "Asia/Muscat",
    value: "Asia/Muscat"
  },
  {
    label: "Asia/Nicosia",
    value: "Asia/Nicosia"
  },
  {
    label: "Asia/Novokuznetsk",
    value: "Asia/Novokuznetsk"
  },
  {
    label: "Asia/Novosibirsk",
    value: "Asia/Novosibirsk"
  },
  {
    label: "Asia/Omsk",
    value: "Asia/Omsk"
  },
  {
    label: "Asia/Oral",
    value: "Asia/Oral"
  },
  {
    label: "Asia/Phnom_Penh",
    value: "Asia/Phnom_Penh"
  },
  {
    label: "Asia/Pontianak",
    value: "Asia/Pontianak"
  },
  {
    label: "Asia/Pyongyang",
    value: "Asia/Pyongyang"
  },
  {
    label: "Asia/Qatar",
    value: "Asia/Qatar"
  },
  {
    label: "Asia/Qyzylorda",
    value: "Asia/Qyzylorda"
  },
  {
    label: "Asia/Rangoon",
    value: "Asia/Rangoon"
  },
  {
    label: "Asia/Riyadh",
    value: "Asia/Riyadh"
  },
  {
    label: "Asia/Saigon",
    value: "Asia/Saigon"
  },
  {
    label: "Asia/Sakhalin",
    value: "Asia/Sakhalin"
  },
  {
    label: "Asia/Samarkand",
    value: "Asia/Samarkand"
  },
  {
    label: "Asia/Seoul",
    value: "Asia/Seoul"
  },
  {
    label: "Asia/Shanghai",
    value: "Asia/Shanghai"
  },
  {
    label: "Asia/Singapore",
    value: "Asia/Singapore"
  },
  {
    label: "Asia/Srednekolymsk",
    value: "Asia/Srednekolymsk"
  },
  {
    label: "Asia/Taipei",
    value: "Asia/Taipei"
  },
  {
    label: "Asia/Tashkent",
    value: "Asia/Tashkent"
  },
  {
    label: "Asia/Tbilisi",
    value: "Asia/Tbilisi"
  },
  {
    label: "Asia/Tehran",
    value: "Asia/Tehran"
  },
  {
    label: "Asia/Tel_Aviv",
    value: "Asia/Tel_Aviv"
  },
  {
    label: "Asia/Thimbu",
    value: "Asia/Thimbu"
  },
  {
    label: "Asia/Thimphu",
    value: "Asia/Thimphu"
  },
  {
    label: "Asia/Tokyo",
    value: "Asia/Tokyo"
  },
  {
    label: "Asia/Tomsk",
    value: "Asia/Tomsk"
  },
  {
    label: "Asia/Ujung_Pandang",
    value: "Asia/Ujung_Pandang"
  },
  {
    label: "Asia/Ulaanbaatar",
    value: "Asia/Ulaanbaatar"
  },
  {
    label: "Asia/Ulan_Bator",
    value: "Asia/Ulan_Bator"
  },
  {
    label: "Asia/Urumqi",
    value: "Asia/Urumqi"
  },
  {
    label: "Asia/Ust-Nera",
    value: "Asia/Ust-Nera"
  },
  {
    label: "Asia/Vientiane",
    value: "Asia/Vientiane"
  },
  {
    label: "Asia/Vladivostok",
    value: "Asia/Vladivostok"
  },
  {
    label: "Asia/Yakutsk",
    value: "Asia/Yakutsk"
  },
  {
    label: "Asia/Yangon",
    value: "Asia/Yangon"
  },
  {
    label: "Asia/Yekaterinburg",
    value: "Asia/Yekaterinburg"
  },
  {
    label: "Asia/Yerevan",
    value: "Asia/Yerevan"
  },
  {
    label: "Atlantic/Azores",
    value: "Atlantic/Azores"
  },
  {
    label: "Atlantic/Bermuda",
    value: "Atlantic/Bermuda"
  },
  {
    label: "Atlantic/Canary",
    value: "Atlantic/Canary"
  },
  {
    label: "Atlantic/Cape_Verde",
    value: "Atlantic/Cape_Verde"
  },
  {
    label: "Atlantic/Faeroe",
    value: "Atlantic/Faeroe"
  },
  {
    label: "Atlantic/Faroe",
    value: "Atlantic/Faroe"
  },
  {
    label: "Atlantic/Jan_Mayen",
    value: "Atlantic/Jan_Mayen"
  },
  {
    label: "Atlantic/Madeira",
    value: "Atlantic/Madeira"
  },
  {
    label: "Atlantic/Reykjavik",
    value: "Atlantic/Reykjavik"
  },
  {
    label: "Atlantic/South_Georgia",
    value: "Atlantic/South_Georgia"
  },
  {
    label: "Atlantic/St_Helena",
    value: "Atlantic/St_Helena"
  },
  {
    label: "Atlantic/Stanley",
    value: "Atlantic/Stanley"
  },
  {
    label: "Australia/ACT",
    value: "Australia/ACT"
  },
  {
    label: "Australia/Adelaide",
    value: "Australia/Adelaide"
  },
  {
    label: "Australia/Brisbane",
    value: "Australia/Brisbane"
  },
  {
    label: "Australia/Broken_Hill",
    value: "Australia/Broken_Hill"
  },
  {
    label: "Australia/Canberra",
    value: "Australia/Canberra"
  },
  {
    label: "Australia/Currie",
    value: "Australia/Currie"
  },
  {
    label: "Australia/Darwin",
    value: "Australia/Darwin"
  },
  {
    label: "Australia/Eucla",
    value: "Australia/Eucla"
  },
  {
    label: "Australia/Hobart",
    value: "Australia/Hobart"
  },
  {
    label: "Australia/LHI",
    value: "Australia/LHI"
  },
  {
    label: "Australia/Lindeman",
    value: "Australia/Lindeman"
  },
  {
    label: "Australia/Lord_Howe",
    value: "Australia/Lord_Howe"
  },
  {
    label: "Australia/Melbourne",
    value: "Australia/Melbourne"
  },
  {
    label: "Australia/NSW",
    value: "Australia/NSW"
  },
  {
    label: "Australia/North",
    value: "Australia/North"
  },
  {
    label: "Australia/Perth",
    value: "Australia/Perth"
  },
  {
    label: "Australia/Queensland",
    value: "Australia/Queensland"
  },
  {
    label: "Australia/South",
    value: "Australia/South"
  },
  {
    label: "Australia/Sydney",
    value: "Australia/Sydney"
  },
  {
    label: "Australia/Tasmania",
    value: "Australia/Tasmania"
  },
  {
    label: "Australia/Victoria",
    value: "Australia/Victoria"
  },
  {
    label: "Australia/West",
    value: "Australia/West"
  },
  {
    label: "Australia/Yancowinna",
    value: "Australia/Yancowinna"
  },
  {
    label: "Brazil/Acre",
    value: "Brazil/Acre"
  },
  {
    label: "Brazil/DeNoronha",
    value: "Brazil/DeNoronha"
  },
  {
    label: "Brazil/East",
    value: "Brazil/East"
  },
  {
    label: "Brazil/West",
    value: "Brazil/West"
  },
  {
    label: "CET",
    value: "CET"
  },
  {
    label: "CST6CDT",
    value: "CST6CDT"
  },
  {
    label: "Canada/Atlantic",
    value: "Canada/Atlantic"
  },
  {
    label: "Canada/Central",
    value: "Canada/Central"
  },
  {
    label: "Canada/Eastern",
    value: "Canada/Eastern"
  },
  {
    label: "Canada/Mountain",
    value: "Canada/Mountain"
  },
  {
    label: "Canada/Newfoundland",
    value: "Canada/Newfoundland"
  },
  {
    label: "Canada/Pacific",
    value: "Canada/Pacific"
  },
  {
    label: "Canada/Saskatchewan",
    value: "Canada/Saskatchewan"
  },
  {
    label: "Canada/Yukon",
    value: "Canada/Yukon"
  },
  {
    label: "Chile/Continental",
    value: "Chile/Continental"
  },
  {
    label: "Chile/EasterIsland",
    value: "Chile/EasterIsland"
  },
  {
    label: "Cuba",
    value: "Cuba"
  },
  {
    label: "EET",
    value: "EET"
  },
  {
    label: "EST",
    value: "EST"
  },
  {
    label: "EST5EDT",
    value: "EST5EDT"
  },
  {
    label: "Egypt",
    value: "Egypt"
  },
  {
    label: "Eire",
    value: "Eire"
  },
  {
    label: "Etc/GMT",
    value: "Etc/GMT"
  },
  {
    label: "Etc/GMT+0",
    value: "Etc/GMT+0"
  },
  {
    label: "Etc/GMT+1",
    value: "Etc/GMT+1"
  },
  {
    label: "Etc/GMT+10",
    value: "Etc/GMT+10"
  },
  {
    label: "Etc/GMT+11",
    value: "Etc/GMT+11"
  },
  {
    label: "Etc/GMT+12",
    value: "Etc/GMT+12"
  },
  {
    label: "Etc/GMT+2",
    value: "Etc/GMT+2"
  },
  {
    label: "Etc/GMT+3",
    value: "Etc/GMT+3"
  },
  {
    label: "Etc/GMT+4",
    value: "Etc/GMT+4"
  },
  {
    label: "Etc/GMT+5",
    value: "Etc/GMT+5"
  },
  {
    label: "Etc/GMT+6",
    value: "Etc/GMT+6"
  },
  {
    label: "Etc/GMT+7",
    value: "Etc/GMT+7"
  },
  {
    label: "Etc/GMT+8",
    value: "Etc/GMT+8"
  },
  {
    label: "Etc/GMT+9",
    value: "Etc/GMT+9"
  },
  {
    label: "Etc/GMT-0",
    value: "Etc/GMT-0"
  },
  {
    label: "Etc/GMT-1",
    value: "Etc/GMT-1"
  },
  {
    label: "Etc/GMT-10",
    value: "Etc/GMT-10"
  },
  {
    label: "Etc/GMT-11",
    value: "Etc/GMT-11"
  },
  {
    label: "Etc/GMT-12",
    value: "Etc/GMT-12"
  },
  {
    label: "Etc/GMT-13",
    value: "Etc/GMT-13"
  },
  {
    label: "Etc/GMT-14",
    value: "Etc/GMT-14"
  },
  {
    label: "Etc/GMT-2",
    value: "Etc/GMT-2"
  },
  {
    label: "Etc/GMT-3",
    value: "Etc/GMT-3"
  },
  {
    label: "Etc/GMT-4",
    value: "Etc/GMT-4"
  },
  {
    label: "Etc/GMT-5",
    value: "Etc/GMT-5"
  },
  {
    label: "Etc/GMT-6",
    value: "Etc/GMT-6"
  },
  {
    label: "Etc/GMT-7",
    value: "Etc/GMT-7"
  },
  {
    label: "Etc/GMT-8",
    value: "Etc/GMT-8"
  },
  {
    label: "Etc/GMT-9",
    value: "Etc/GMT-9"
  },
  {
    label: "Etc/GMT0",
    value: "Etc/GMT0"
  },
  {
    label: "Etc/Greenwich",
    value: "Etc/Greenwich"
  },
  {
    label: "Etc/UCT",
    value: "Etc/UCT"
  },
  {
    label: "Etc/UTC",
    value: "Etc/UTC"
  },
  {
    label: "Etc/Universal",
    value: "Etc/Universal"
  },
  {
    label: "Etc/Zulu",
    value: "Etc/Zulu"
  },
  {
    label: "Europe/Amsterdam",
    value: "Europe/Amsterdam"
  },
  {
    label: "Europe/Andorra",
    value: "Europe/Andorra"
  },
  {
    label: "Europe/Astrakhan",
    value: "Europe/Astrakhan"
  },
  {
    label: "Europe/Athens",
    value: "Europe/Athens"
  },
  {
    label: "Europe/Belfast",
    value: "Europe/Belfast"
  },
  {
    label: "Europe/Belgrade",
    value: "Europe/Belgrade"
  },
  {
    label: "Europe/Berlin",
    value: "Europe/Berlin"
  },
  {
    label: "Europe/Bratislava",
    value: "Europe/Bratislava"
  },
  {
    label: "Europe/Brussels",
    value: "Europe/Brussels"
  },
  {
    label: "Europe/Bucharest",
    value: "Europe/Bucharest"
  },
  {
    label: "Europe/Budapest",
    value: "Europe/Budapest"
  },
  {
    label: "Europe/Busingen",
    value: "Europe/Busingen"
  },
  {
    label: "Europe/Chisinau",
    value: "Europe/Chisinau"
  },
  {
    label: "Europe/Copenhagen",
    value: "Europe/Copenhagen"
  },
  {
    label: "Europe/Dublin",
    value: "Europe/Dublin"
  },
  {
    label: "Europe/Gibraltar",
    value: "Europe/Gibraltar"
  },
  {
    label: "Europe/Guernsey",
    value: "Europe/Guernsey"
  },
  {
    label: "Europe/Helsinki",
    value: "Europe/Helsinki"
  },
  {
    label: "Europe/Isle_of_Man",
    value: "Europe/Isle_of_Man"
  },
  {
    label: "Europe/Istanbul",
    value: "Europe/Istanbul"
  },
  {
    label: "Europe/Jersey",
    value: "Europe/Jersey"
  },
  {
    label: "Europe/Kaliningrad",
    value: "Europe/Kaliningrad"
  },
  {
    label: "Europe/Kiev",
    value: "Europe/Kiev"
  },
  {
    label: "Europe/Kirov",
    value: "Europe/Kirov"
  },
  {
    label: "Europe/Lisbon",
    value: "Europe/Lisbon"
  },
  {
    label: "Europe/Ljubljana",
    value: "Europe/Ljubljana"
  },
  {
    label: "Europe/London",
    value: "Europe/London"
  },
  {
    label: "Europe/Luxembourg",
    value: "Europe/Luxembourg"
  },
  {
    label: "Europe/Madrid",
    value: "Europe/Madrid"
  },
  {
    label: "Europe/Malta",
    value: "Europe/Malta"
  },
  {
    label: "Europe/Mariehamn",
    value: "Europe/Mariehamn"
  },
  {
    label: "Europe/Minsk",
    value: "Europe/Minsk"
  },
  {
    label: "Europe/Monaco",
    value: "Europe/Monaco"
  },
  {
    label: "Europe/Moscow",
    value: "Europe/Moscow"
  },
  {
    label: "Europe/Nicosia",
    value: "Europe/Nicosia"
  },
  {
    label: "Europe/Oslo",
    value: "Europe/Oslo"
  },
  {
    label: "Europe/Paris",
    value: "Europe/Paris"
  },
  {
    label: "Europe/Podgorica",
    value: "Europe/Podgorica"
  },
  {
    label: "Europe/Prague",
    value: "Europe/Prague"
  },
  {
    label: "Europe/Riga",
    value: "Europe/Riga"
  },
  {
    label: "Europe/Rome",
    value: "Europe/Rome"
  },
  {
    label: "Europe/Samara",
    value: "Europe/Samara"
  },
  {
    label: "Europe/San_Marino",
    value: "Europe/San_Marino"
  },
  {
    label: "Europe/Sarajevo",
    value: "Europe/Sarajevo"
  },
  {
    label: "Europe/Saratov",
    value: "Europe/Saratov"
  },
  {
    label: "Europe/Simferopol",
    value: "Europe/Simferopol"
  },
  {
    label: "Europe/Skopje",
    value: "Europe/Skopje"
  },
  {
    label: "Europe/Sofia",
    value: "Europe/Sofia"
  },
  {
    label: "Europe/Stockholm",
    value: "Europe/Stockholm"
  },
  {
    label: "Europe/Tallinn",
    value: "Europe/Tallinn"
  },
  {
    label: "Europe/Tirane",
    value: "Europe/Tirane"
  },
  {
    label: "Europe/Tiraspol",
    value: "Europe/Tiraspol"
  },
  {
    label: "Europe/Ulyanovsk",
    value: "Europe/Ulyanovsk"
  },
  {
    label: "Europe/Uzhgorod",
    value: "Europe/Uzhgorod"
  },
  {
    label: "Europe/Vaduz",
    value: "Europe/Vaduz"
  },
  {
    label: "Europe/Vatican",
    value: "Europe/Vatican"
  },
  {
    label: "Europe/Vienna",
    value: "Europe/Vienna"
  },
  {
    label: "Europe/Vilnius",
    value: "Europe/Vilnius"
  },
  {
    label: "Europe/Volgograd",
    value: "Europe/Volgograd"
  },
  {
    label: "Europe/Warsaw",
    value: "Europe/Warsaw"
  },
  {
    label: "Europe/Zagreb",
    value: "Europe/Zagreb"
  },
  {
    label: "Europe/Zaporozhye",
    value: "Europe/Zaporozhye"
  },
  {
    label: "Europe/Zurich",
    value: "Europe/Zurich"
  },
  {
    label: "GB",
    value: "GB"
  },
  {
    label: "GB-Eire",
    value: "GB-Eire"
  },
  {
    label: "GMT",
    value: "GMT"
  },
  {
    label: "GMT+0",
    value: "GMT+0"
  },
  {
    label: "GMT-0",
    value: "GMT-0"
  },
  {
    label: "GMT0",
    value: "GMT0"
  },
  {
    label: "Greenwich",
    value: "Greenwich"
  },
  {
    label: "HST",
    value: "HST"
  },
  {
    label: "Hongkong",
    value: "Hongkong"
  },
  {
    label: "Iceland",
    value: "Iceland"
  },
  {
    label: "Indian/Antananarivo",
    value: "Indian/Antananarivo"
  },
  {
    label: "Indian/Chagos",
    value: "Indian/Chagos"
  },
  {
    label: "Indian/Christmas",
    value: "Indian/Christmas"
  },
  {
    label: "Indian/Cocos",
    value: "Indian/Cocos"
  },
  {
    label: "Indian/Comoro",
    value: "Indian/Comoro"
  },
  {
    label: "Indian/Kerguelen",
    value: "Indian/Kerguelen"
  },
  {
    label: "Indian/Mahe",
    value: "Indian/Mahe"
  },
  {
    label: "Indian/Maldives",
    value: "Indian/Maldives"
  },
  {
    label: "Indian/Mauritius",
    value: "Indian/Mauritius"
  },
  {
    label: "Indian/Mayotte",
    value: "Indian/Mayotte"
  },
  {
    label: "Indian/Reunion",
    value: "Indian/Reunion"
  },
  {
    label: "Iran",
    value: "Iran"
  },
  {
    label: "Israel",
    value: "Israel"
  },
  {
    label: "Jamaica",
    value: "Jamaica"
  },
  {
    label: "Japan",
    value: "Japan"
  },
  {
    label: "Kwajalein",
    value: "Kwajalein"
  },
  {
    label: "Libya",
    value: "Libya"
  },
  {
    label: "MET",
    value: "MET"
  },
  {
    label: "MST",
    value: "MST"
  },
  {
    label: "MST7MDT",
    value: "MST7MDT"
  },
  {
    label: "Mexico/BajaNorte",
    value: "Mexico/BajaNorte"
  },
  {
    label: "Mexico/BajaSur",
    value: "Mexico/BajaSur"
  },
  {
    label: "Mexico/General",
    value: "Mexico/General"
  },
  {
    label: "NZ",
    value: "NZ"
  },
  {
    label: "NZ-CHAT",
    value: "NZ-CHAT"
  },
  {
    label: "Navajo",
    value: "Navajo"
  },
  {
    label: "PRC",
    value: "PRC"
  },
  {
    label: "PST8PDT",
    value: "PST8PDT"
  },
  {
    label: "Pacific/Apia",
    value: "Pacific/Apia"
  },
  {
    label: "Pacific/Auckland",
    value: "Pacific/Auckland"
  },
  {
    label: "Pacific/Bougainville",
    value: "Pacific/Bougainville"
  },
  {
    label: "Pacific/Chatham",
    value: "Pacific/Chatham"
  },
  {
    label: "Pacific/Chuuk",
    value: "Pacific/Chuuk"
  },
  {
    label: "Pacific/Easter",
    value: "Pacific/Easter"
  },
  {
    label: "Pacific/Efate",
    value: "Pacific/Efate"
  },
  {
    label: "Pacific/Enderbury",
    value: "Pacific/Enderbury"
  },
  {
    label: "Pacific/Fakaofo",
    value: "Pacific/Fakaofo"
  },
  {
    label: "Pacific/Fiji",
    value: "Pacific/Fiji"
  },
  {
    label: "Pacific/Funafuti",
    value: "Pacific/Funafuti"
  },
  {
    label: "Pacific/Galapagos",
    value: "Pacific/Galapagos"
  },
  {
    label: "Pacific/Gambier",
    value: "Pacific/Gambier"
  },
  {
    label: "Pacific/Guadalcanal",
    value: "Pacific/Guadalcanal"
  },
  {
    label: "Pacific/Guam",
    value: "Pacific/Guam"
  },
  {
    label: "Pacific/Honolulu",
    value: "Pacific/Honolulu"
  },
  {
    label: "Pacific/Johnston",
    value: "Pacific/Johnston"
  },
  {
    label: "Pacific/Kiritimati",
    value: "Pacific/Kiritimati"
  },
  {
    label: "Pacific/Kosrae",
    value: "Pacific/Kosrae"
  },
  {
    label: "Pacific/Kwajalein",
    value: "Pacific/Kwajalein"
  },
  {
    label: "Pacific/Majuro",
    value: "Pacific/Majuro"
  },
  {
    label: "Pacific/Marquesas",
    value: "Pacific/Marquesas"
  },
  {
    label: "Pacific/Midway",
    value: "Pacific/Midway"
  },
  {
    label: "Pacific/Nauru",
    value: "Pacific/Nauru"
  },
  {
    label: "Pacific/Niue",
    value: "Pacific/Niue"
  },
  {
    label: "Pacific/Norfolk",
    value: "Pacific/Norfolk"
  },
  {
    label: "Pacific/Noumea",
    value: "Pacific/Noumea"
  },
  {
    label: "Pacific/Pago_Pago",
    value: "Pacific/Pago_Pago"
  },
  {
    label: "Pacific/Palau",
    value: "Pacific/Palau"
  },
  {
    label: "Pacific/Pitcairn",
    value: "Pacific/Pitcairn"
  },
  {
    label: "Pacific/Pohnpei",
    value: "Pacific/Pohnpei"
  },
  {
    label: "Pacific/Ponape",
    value: "Pacific/Ponape"
  },
  {
    label: "Pacific/Port_Moresby",
    value: "Pacific/Port_Moresby"
  },
  {
    label: "Pacific/Rarotonga",
    value: "Pacific/Rarotonga"
  },
  {
    label: "Pacific/Saipan",
    value: "Pacific/Saipan"
  },
  {
    label: "Pacific/Samoa",
    value: "Pacific/Samoa"
  },
  {
    label: "Pacific/Tahiti",
    value: "Pacific/Tahiti"
  },
  {
    label: "Pacific/Tarawa",
    value: "Pacific/Tarawa"
  },
  {
    label: "Pacific/Tongatapu",
    value: "Pacific/Tongatapu"
  },
  {
    label: "Pacific/Truk",
    value: "Pacific/Truk"
  },
  {
    label: "Pacific/Wake",
    value: "Pacific/Wake"
  },
  {
    label: "Pacific/Wallis",
    value: "Pacific/Wallis"
  },
  {
    label: "Pacific/Yap",
    value: "Pacific/Yap"
  },
  {
    label: "Poland",
    value: "Poland"
  },
  {
    label: "Portugal",
    value: "Portugal"
  },
  {
    label: "ROC",
    value: "ROC"
  },
  {
    label: "ROK",
    value: "ROK"
  },
  {
    label: "Singapore",
    value: "Singapore"
  },
  {
    label: "Turkey",
    value: "Turkey"
  },
  {
    label: "UCT",
    value: "UCT"
  },
  {
    label: "US/Alaska",
    value: "US/Alaska"
  },
  {
    label: "US/Aleutian",
    value: "US/Aleutian"
  },
  {
    label: "US/Arizona",
    value: "US/Arizona"
  },
  {
    label: "US/Central",
    value: "US/Central"
  },
  {
    label: "US/East-Indiana",
    value: "US/East-Indiana"
  },
  {
    label: "US/Eastern",
    value: "US/Eastern"
  },
  {
    label: "US/Hawaii",
    value: "US/Hawaii"
  },
  {
    label: "US/Indiana-Starke",
    value: "US/Indiana-Starke"
  },
  {
    label: "US/Michigan",
    value: "US/Michigan"
  },
  {
    label: "US/Mountain",
    value: "US/Mountain"
  },
  {
    label: "US/Pacific",
    value: "US/Pacific"
  },
  {
    label: "US/Pacific-New",
    value: "US/Pacific-New"
  },
  {
    label: "US/Samoa",
    value: "US/Samoa"
  },
  {
    label: "UTC",
    value: "UTC"
  },
  {
    label: "Universal",
    value: "Universal"
  },
  {
    label: "W-SU",
    value: "W-SU"
  },
  {
    label: "WET",
    value: "WET"
  },
  {
    label: "Zulu",
    value: "Zulu"
  }
];

const timeZoneData = {
  "Pacific/Pago_Pago": "-11:00",
  "Pacific/Samoa": "-11:00",
  "Pacific/Niue": "-11:00",
  "US/Samoa": "-11:00",
  "Pacific/Midway": "-11:00",
  "Pacific/Honolulu": "-10:00",
  "Pacific/Rarotonga": "-10:00",
  "Pacific/Tahiti": "-10:00",
  "Pacific/Johnston": "-10:00",
  "US/Hawaii": "-10:00",
  "SystemV/HST10": "-10:00",
  "Pacific/Marquesas": "-09:30",
  "Pacific/Gambier": "-09:00",
  "America/Atka": "-09:00",
  "SystemV/YST9": "-09:00",
  "America/Adak": "-09:00",
  "US/Aleutian": "-09:00",
  "US/Alaska": "-08:00",
  "America/Juneau": "-08:00",
  "America/Metlakatla": "-08:00",
  "America/Yakutat": "-08:00",
  "Pacific/Pitcairn": "-08:00",
  "America/Sitka": "-08:00",
  "America/Anchorage": "-08:00",
  "SystemV/PST8": "-08:00",
  "America/Nome": "-08:00",
  "SystemV/YST9YDT": "-08:00",
  "Canada/Yukon": "-07:00",
  "US/Pacific-New": "-07:00",
  "US/Arizona": "-07:00",
  "America/Dawson_Creek": "-07:00",
  "Canada/Pacific": "-07:00",
  PST8PDT: "-07:00",
  "SystemV/MST7": "-07:00",
  "America/Dawson": "-07:00",
  "Mexico/BajaNorte": "-07:00",
  "America/Tijuana": "-07:00",
  "America/Creston": "-07:00",
  "America/Hermosillo": "-07:00",
  "America/Santa_Isabel": "-07:00",
  "America/Vancouver": "-07:00",
  "America/Ensenada": "-07:00",
  "America/Phoenix": "-07:00",
  "America/Whitehorse": "-07:00",
  "America/Fort_Nelson": "-07:00",
  "SystemV/PST8PDT": "-07:00",
  "America/Los_Angeles": "-07:00",
  "US/Pacific": "-07:00",
  "America/El_Salvador": "-06:00",
  "America/Guatemala": "-06:00",
  "America/Belize": "-06:00",
  "America/Managua": "-06:00",
  "America/Tegucigalpa": "-06:00",
  "Pacific/Easter": "-06:00",
  "Mexico/BajaSur": "-06:00",
  "America/Regina": "-06:00",
  "America/Denver": "-06:00",
  "Pacific/Galapagos": "-06:00",
  "America/Yellowknife": "-06:00",
  "America/Swift_Current": "-06:00",
  "America/Inuvik": "-06:00",
  "America/Mazatlan": "-06:00",
  "America/Boise": "-06:00",
  "America/Costa_Rica": "-06:00",
  MST7MDT: "-06:00",
  "SystemV/CST6": "-06:00",
  "America/Chihuahua": "-06:00",
  "America/Ojinaga": "-06:00",
  "Chile/EasterIsland": "-06:00",
  "US/Mountain": "-06:00",
  "America/Edmonton": "-06:00",
  "Canada/Mountain": "-06:00",
  "America/Cambridge_Bay": "-06:00",
  Navajo: "-06:00",
  "SystemV/MST7MDT": "-06:00",
  "Canada/Saskatchewan": "-06:00",
  "America/Shiprock": "-06:00",
  "America/Panama": "-05:00",
  "America/Chicago": "-05:00",
  "America/Eirunepe": "-05:00",
  "Mexico/General": "-05:00",
  "America/Porto_Acre": "-05:00",
  "America/Guayaquil": "-05:00",
  "America/Rankin_Inlet": "-05:00",
  "US/Central": "-05:00",
  "America/Rainy_River": "-05:00",
  "America/Indiana/Knox": "-05:00",
  "America/North_Dakota/Beulah": "-05:00",
  "America/Monterrey": "-05:00",
  "America/Jamaica": "-05:00",
  "America/Atikokan": "-05:00",
  "America/Coral_Harbour": "-05:00",
  "America/North_Dakota/Center": "-05:00",
  "America/Cayman": "-05:00",
  "America/Indiana/Tell_City": "-05:00",
  "America/Mexico_City": "-05:00",
  "America/Matamoros": "-05:00",
  CST6CDT: "-05:00",
  "America/Knox_IN": "-05:00",
  "America/Bogota": "-05:00",
  "America/Menominee": "-05:00",
  "America/Resolute": "-05:00",
  "SystemV/EST5": "-05:00",
  "Canada/Central": "-05:00",
  "Brazil/Acre": "-05:00",
  "America/Cancun": "-05:00",
  "America/Lima": "-05:00",
  "America/Bahia_Banderas": "-05:00",
  "US/Indiana-Starke": "-05:00",
  "America/Rio_Branco": "-05:00",
  "SystemV/CST6CDT": "-05:00",
  Jamaica: "-05:00",
  "America/Merida": "-05:00",
  "America/North_Dakota/New_Salem": "-05:00",
  "America/Winnipeg": "-05:00",
  "America/Cuiaba": "-04:00",
  "America/Marigot": "-04:00",
  "America/Indiana/Petersburg": "-04:00",
  "Chile/Continental": "-04:00",
  "America/Grand_Turk": "-04:00",
  Cuba: "-04:00",
  "America/Manaus": "-04:00",
  "America/Fort_Wayne": "-04:00",
  "America/St_Thomas": "-04:00",
  "America/Anguilla": "-04:00",
  "America/Havana": "-04:00",
  "US/Michigan": "-04:00",
  "America/Barbados": "-04:00",
  "America/Louisville": "-04:00",
  "America/Curacao": "-04:00",
  "America/Guyana": "-04:00",
  "America/Martinique": "-04:00",
  "America/Puerto_Rico": "-04:00",
  "America/Port_of_Spain": "-04:00",
  "SystemV/AST4": "-04:00",
  "America/Indiana/Vevay": "-04:00",
  "America/Indiana/Vincennes": "-04:00",
  "America/Kralendijk": "-04:00",
  "America/Antigua": "-04:00",
  "America/Indianapolis": "-04:00",
  "America/Iqaluit": "-04:00",
  "America/St_Vincent": "-04:00",
  "America/Kentucky/Louisville": "-04:00",
  "America/Dominica": "-04:00",
  "America/Asuncion": "-04:00",
  EST5EDT: "-04:00",
  "America/Nassau": "-04:00",
  "America/Kentucky/Monticello": "-04:00",
  "Brazil/West": "-04:00",
  "America/Aruba": "-04:00",
  "America/Indiana/Indianapolis": "-04:00",
  "America/Santiago": "-04:00",
  "America/La_Paz": "-04:00",
  "America/Thunder_Bay": "-04:00",
  "America/Indiana/Marengo": "-04:00",
  "America/Blanc-Sablon": "-04:00",
  "America/Santo_Domingo": "-04:00",
  "US/Eastern": "-04:00",
  "Canada/Eastern": "-04:00",
  "America/Port-au-Prince": "-04:00",
  "America/St_Barthelemy": "-04:00",
  "America/Nipigon": "-04:00",
  "US/East-Indiana": "-04:00",
  "America/St_Lucia": "-04:00",
  "America/Montserrat": "-04:00",
  "America/Lower_Princes": "-04:00",
  "America/Detroit": "-04:00",
  "America/Tortola": "-04:00",
  "America/Porto_Velho": "-04:00",
  "America/Campo_Grande": "-04:00",
  "America/Virgin": "-04:00",
  "America/Pangnirtung": "-04:00",
  "America/Montreal": "-04:00",
  "America/Indiana/Winamac": "-04:00",
  "America/Boa_Vista": "-04:00",
  "America/Grenada": "-04:00",
  "America/New_York": "-04:00",
  "America/St_Kitts": "-04:00",
  "America/Caracas": "-04:00",
  "America/Guadeloupe": "-04:00",
  "America/Toronto": "-04:00",
  "SystemV/EST5EDT": "-04:00",
  "America/Argentina/Catamarca": "-03:00",
  "Canada/Atlantic": "-03:00",
  "America/Argentina/Cordoba": "-03:00",
  "America/Araguaina": "-03:00",
  "America/Argentina/Salta": "-03:00",
  "America/Montevideo": "-03:00",
  "Brazil/East": "-03:00",
  "America/Argentina/Mendoza": "-03:00",
  "America/Argentina/Rio_Gallegos": "-03:00",
  "America/Catamarca": "-03:00",
  "America/Cordoba": "-03:00",
  "America/Sao_Paulo": "-03:00",
  "America/Argentina/Jujuy": "-03:00",
  "America/Cayenne": "-03:00",
  "America/Recife": "-03:00",
  "America/Buenos_Aires": "-03:00",
  "America/Paramaribo": "-03:00",
  "America/Moncton": "-03:00",
  "America/Mendoza": "-03:00",
  "America/Santarem": "-03:00",
  "Atlantic/Bermuda": "-03:00",
  "America/Maceio": "-03:00",
  "Atlantic/Stanley": "-03:00",
  "America/Halifax": "-03:00",
  "Antarctica/Rothera": "-03:00",
  "America/Argentina/San_Luis": "-03:00",
  "America/Argentina/Ushuaia": "-03:00",
  "Antarctica/Palmer": "-03:00",
  "America/Punta_Arenas": "-03:00",
  "America/Glace_Bay": "-03:00",
  "America/Fortaleza": "-03:00",
  "America/Thule": "-03:00",
  "America/Argentina/La_Rioja": "-03:00",
  "America/Belem": "-03:00",
  "America/Jujuy": "-03:00",
  "America/Bahia": "-03:00",
  "America/Goose_Bay": "-03:00",
  "America/Argentina/San_Juan": "-03:00",
  "America/Argentina/ComodRivadavia": "-03:00",
  "America/Argentina/Tucuman": "-03:00",
  "America/Rosario": "-03:00",
  "SystemV/AST4ADT": "-03:00",
  "America/Argentina/Buenos_Aires": "-03:00",
  "America/St_Johns": "-02:30",
  "Canada/Newfoundland": "-02:30",
  "America/Miquelon": "-02:00",
  "America/Godthab": "-02:00",
  "America/Noronha": "-02:00",
  "Brazil/DeNoronha": "-02:00",
  "Atlantic/South_Georgia": "-02:00",
  "Atlantic/Cape_Verde": "-01:00",
  "Pacific/Kiritimati": "+14:00",
  "Pacific/Fakaofo": "+13:00",
  "Pacific/Enderbury": "+13:00",
  "Pacific/Apia": "+13:00",
  "Pacific/Tongatapu": "+13:00",
  "NZ-CHAT": "+12:45",
  "Pacific/Chatham": "+12:45",
  "Pacific/Kwajalein": "+12:00",
  "Antarctica/McMurdo": "+12:00",
  "Pacific/Wallis": "+12:00",
  "Pacific/Fiji": "+12:00",
  "Pacific/Funafuti": "+12:00",
  "Pacific/Nauru": "+12:00",
  Kwajalein: "+12:00",
  NZ: "+12:00",
  "Pacific/Wake": "+12:00",
  "Antarctica/South_Pole": "+12:00",
  "Pacific/Tarawa": "+12:00",
  "Pacific/Auckland": "+12:00",
  "Asia/Kamchatka": "+12:00",
  "Asia/Anadyr": "+12:00",
  "Pacific/Majuro": "+12:00",
  "Pacific/Ponape": "+11:00",
  "Pacific/Bougainville": "+11:00",
  "Antarctica/Macquarie": "+11:00",
  "Pacific/Pohnpei": "+11:00",
  "Pacific/Efate": "+11:00",
  "Pacific/Norfolk": "+11:00",
  "Asia/Magadan": "+11:00",
  "Pacific/Kosrae": "+11:00",
  "Asia/Sakhalin": "+11:00",
  "Pacific/Noumea": "+11:00",
  "Asia/Srednekolymsk": "+11:00",
  "Pacific/Guadalcanal": "+11:00",
  "Australia/Lord_Howe": "+10:30",
  "Australia/LHI": "+10:30",
  "Australia/Hobart": "+10:00",
  "Pacific/Yap": "+10:00",
  "Australia/Tasmania": "+10:00",
  "Pacific/Port_Moresby": "+10:00",
  "Australia/ACT": "+10:00",
  "Australia/Victoria": "+10:00",
  "Pacific/Chuuk": "+10:00",
  "Australia/Queensland": "+10:00",
  "Australia/Canberra": "+10:00",
  "Australia/Currie": "+10:00",
  "Pacific/Guam": "+10:00",
  "Pacific/Truk": "+10:00",
  "Australia/NSW": "+10:00",
  "Asia/Vladivostok": "+10:00",
  "Pacific/Saipan": "+10:00",
  "Antarctica/DumontDUrville": "+10:00",
  "Australia/Sydney": "+10:00",
  "Australia/Brisbane": "+10:00",
  "Asia/Ust-Nera": "+10:00",
  "Australia/Melbourne": "+10:00",
  "Australia/Lindeman": "+10:00",
  "Australia/North": "+09:30",
  "Australia/Yancowinna": "+09:30",
  "Australia/Adelaide": "+09:30",
  "Australia/Broken_Hill": "+09:30",
  "Australia/South": "+09:30",
  "Australia/Darwin": "+09:30",
  "Pacific/Palau": "+09:00",
  "Asia/Chita": "+09:00",
  "Asia/Dili": "+09:00",
  "Asia/Jayapura": "+09:00",
  "Asia/Yakutsk": "+09:00",
  "Asia/Pyongyang": "+09:00",
  ROK: "+09:00",
  "Asia/Seoul": "+09:00",
  "Asia/Khandyga": "+09:00",
  Japan: "+09:00",
  "Asia/Tokyo": "+09:00",
  "Australia/Eucla": "+08:45",
  "Asia/Kuching": "+08:00",
  "Asia/Chungking": "+08:00",
  "Australia/Perth": "+08:00",
  "Asia/Macao": "+08:00",
  "Asia/Macau": "+08:00",
  "Asia/Choibalsan": "+08:00",
  "Asia/Shanghai": "+08:00",
  "Antarctica/Casey": "+08:00",
  "Asia/Ulan_Bator": "+08:00",
  "Asia/Chongqing": "+08:00",
  "Asia/Ulaanbaatar": "+08:00",
  "Asia/Taipei": "+08:00",
  "Asia/Manila": "+08:00",
  PRC: "+08:00",
  "Asia/Ujung_Pandang": "+08:00",
  "Asia/Harbin": "+08:00",
  Singapore: "+08:00",
  "Asia/Brunei": "+08:00",
  "Australia/West": "+08:00",
  "Asia/Hong_Kong": "+08:00",
  "Asia/Makassar": "+08:00",
  Hongkong: "+08:00",
  "Asia/Kuala_Lumpur": "+08:00",
  "Asia/Irkutsk": "+08:00",
  "Asia/Singapore": "+08:00",
  "Asia/Pontianak": "+07:00",
  "Asia/Phnom_Penh": "+07:00",
  "Asia/Novosibirsk": "+07:00",
  "Antarctica/Davis": "+07:00",
  "Asia/Tomsk": "+07:00",
  "Asia/Jakarta": "+07:00",
  "Asia/Barnaul": "+07:00",
  "Indian/Christmas": "+07:00",
  "Asia/Ho_Chi_Minh": "+07:00",
  "Asia/Hovd": "+07:00",
  "Asia/Bangkok": "+07:00",
  "Asia/Vientiane": "+07:00",
  "Asia/Novokuznetsk": "+07:00",
  "Asia/Krasnoyarsk": "+07:00",
  "Asia/Saigon": "+07:00",
  "Asia/Yangon": "+06:30",
  "Asia/Rangoon": "+06:30",
  "Indian/Cocos": "+06:30",
  "Asia/Kashgar": "+06:00",
  "Asia/Almaty": "+06:00",
  "Asia/Dacca": "+06:00",
  "Asia/Omsk": "+06:00",
  "Asia/Dhaka": "+06:00",
  "Indian/Chagos": "+06:00",
  "Asia/Qostanay": "+06:00",
  "Asia/Bishkek": "+06:00",
  "Antarctica/Vostok": "+06:00",
  "Asia/Urumqi": "+06:00",
  "Asia/Thimbu": "+06:00",
  "Asia/Thimphu": "+06:00",
  "Asia/Kathmandu": "+05:45",
  "Asia/Katmandu": "+05:45",
  "Asia/Kolkata": "+05:30",
  "Asia/Colombo": "+05:30",
  "Asia/Calcutta": "+05:30",
  "Asia/Aqtau": "+05:00",
  "Asia/Samarkand": "+05:00",
  "Asia/Karachi": "+05:00",
  "Asia/Yekaterinburg": "+05:00",
  "Asia/Dushanbe": "+05:00",
  "Indian/Maldives": "+05:00",
  "Asia/Oral": "+05:00",
  "Asia/Tashkent": "+05:00",
  "Antarctica/Mawson": "+05:00",
  "Asia/Qyzylorda": "+05:00",
  "Asia/Aqtobe": "+05:00",
  "Asia/Ashkhabad": "+05:00",
  "Asia/Ashgabat": "+05:00",
  "Asia/Atyrau": "+05:00",
  "Indian/Kerguelen": "+05:00",
  Iran: "+04:30",
  "Asia/Tehran": "+04:30",
  "Asia/Kabul": "+04:30",
  "Asia/Yerevan": "+04:00",
  "Asia/Dubai": "+04:00",
  "Indian/Reunion": "+04:00",
  "Indian/Mauritius": "+04:00",
  "Europe/Saratov": "+04:00",
  "Europe/Samara": "+04:00",
  "Indian/Mahe": "+04:00",
  "Asia/Baku": "+04:00",
  "Asia/Muscat": "+04:00",
  "Europe/Volgograd": "+04:00",
  "Europe/Astrakhan": "+04:00",
  "Asia/Tbilisi": "+04:00",
  "Europe/Ulyanovsk": "+04:00",
  "Asia/Aden": "+03:00",
  "Africa/Nairobi": "+03:00",
  "Europe/Istanbul": "+03:00",
  "Europe/Zaporozhye": "+03:00",
  Israel: "+03:00",
  "Indian/Comoro": "+03:00",
  "Antarctica/Syowa": "+03:00",
  "Africa/Mogadishu": "+03:00",
  "Europe/Bucharest": "+03:00",
  "Africa/Asmera": "+03:00",
  "Europe/Mariehamn": "+03:00",
  "Asia/Istanbul": "+03:00",
  "Europe/Tiraspol": "+03:00",
  "Europe/Moscow": "+03:00",
  "Europe/Chisinau": "+03:00",
  "Europe/Helsinki": "+03:00",
  "Asia/Beirut": "+03:00",
  "Asia/Tel_Aviv": "+03:00",
  "Africa/Djibouti": "+03:00",
  "Europe/Simferopol": "+03:00",
  "Europe/Sofia": "+03:00",
  "Asia/Gaza": "+03:00",
  "Africa/Asmara": "+03:00",
  "Europe/Riga": "+03:00",
  "Asia/Baghdad": "+03:00",
  "Asia/Damascus": "+03:00",
  "Africa/Dar_es_Salaam": "+03:00",
  "Africa/Addis_Ababa": "+03:00",
  "Europe/Uzhgorod": "+03:00",
  "Asia/Jerusalem": "+03:00",
  "Asia/Riyadh": "+03:00",
  "Asia/Kuwait": "+03:00",
  "Europe/Kirov": "+03:00",
  "Africa/Kampala": "+03:00",
  "Europe/Minsk": "+03:00",
  "Asia/Qatar": "+03:00",
  "Europe/Kiev": "+03:00",
  "Asia/Bahrain": "+03:00",
  "Europe/Vilnius": "+03:00",
  "Indian/Antananarivo": "+03:00",
  "Indian/Mayotte": "+03:00",
  "Europe/Tallinn": "+03:00",
  Turkey: "+03:00",
  "Africa/Juba": "+03:00",
  "Asia/Nicosia": "+03:00",
  "Asia/Famagusta": "+03:00",
  "W-SU": "+03:00",
  EET: "+03:00",
  "Asia/Hebron": "+03:00",
  "Asia/Amman": "+03:00",
  "Europe/Nicosia": "+03:00",
  "Europe/Athens": "+03:00",
  "Africa/Cairo": "+02:00",
  "Africa/Mbabane": "+02:00",
  "Europe/Brussels": "+02:00",
  "Europe/Warsaw": "+02:00",
  CET: "+02:00",
  "Europe/Luxembourg": "+02:00",
  Libya: "+02:00",
  "Africa/Kigali": "+02:00",
  "Africa/Tripoli": "+02:00",
  "Europe/Kaliningrad": "+02:00",
  "Africa/Windhoek": "+02:00",
  "Europe/Malta": "+02:00",
  "Europe/Busingen": "+02:00",
  "Europe/Skopje": "+02:00",
  "Europe/Sarajevo": "+02:00",
  "Europe/Rome": "+02:00",
  "Europe/Zurich": "+02:00",
  "Europe/Gibraltar": "+02:00",
  "Africa/Lubumbashi": "+02:00",
  "Europe/Vaduz": "+02:00",
  "Europe/Ljubljana": "+02:00",
  "Europe/Berlin": "+02:00",
  "Europe/Stockholm": "+02:00",
  "Europe/Budapest": "+02:00",
  "Europe/Zagreb": "+02:00",
  "Europe/Paris": "+02:00",
  "Africa/Ceuta": "+02:00",
  "Europe/Prague": "+02:00",
  "Antarctica/Troll": "+02:00",
  "Africa/Gaborone": "+02:00",
  "Europe/Copenhagen": "+02:00",
  "Europe/Vienna": "+02:00",
  "Europe/Tirane": "+02:00",
  MET: "+02:00",
  "Europe/Amsterdam": "+02:00",
  "Africa/Maputo": "+02:00",
  "Europe/San_Marino": "+02:00",
  Poland: "+02:00",
  "Europe/Andorra": "+02:00",
  "Europe/Oslo": "+02:00",
  "Europe/Podgorica": "+02:00",
  "Africa/Bujumbura": "+02:00",
  "Atlantic/Jan_Mayen": "+02:00",
  "Africa/Maseru": "+02:00",
  "Europe/Madrid": "+02:00",
  "Africa/Blantyre": "+02:00",
  "Africa/Lusaka": "+02:00",
  "Africa/Harare": "+02:00",
  "Africa/Khartoum": "+02:00",
  "Africa/Johannesburg": "+02:00",
  "Europe/Belgrade": "+02:00",
  "Europe/Bratislava": "+02:00",
  "Arctic/Longyearbyen": "+02:00",
  Egypt: "+02:00",
  "Europe/Vatican": "+02:00",
  "Europe/Monaco": "+02:00",
  "Europe/London": "+01:00",
  "Europe/Jersey": "+01:00",
  "Europe/Guernsey": "+01:00",
  "Europe/Isle_of_Man": "+01:00",
  "Africa/Tunis": "+01:00",
  "Africa/Malabo": "+01:00",
  "GB-Eire": "+01:00",
  "Africa/Lagos": "+01:00",
  "Africa/Algiers": "+01:00",
  GB: "+01:00",
  Portugal: "+01:00",
  "Africa/Ndjamena": "+01:00",
  "Atlantic/Faeroe": "+01:00",
  Eire: "+01:00",
  "Atlantic/Faroe": "+01:00",
  "Europe/Dublin": "+01:00",
  "Africa/Libreville": "+01:00",
  "Africa/El_Aaiun": "+01:00",
  "Africa/Douala": "+01:00",
  "Africa/Brazzaville": "+01:00",
  "Africa/Porto-Novo": "+01:00",
  "Atlantic/Madeira": "+01:00",
  "Europe/Lisbon": "+01:00",
  "Atlantic/Canary": "+01:00",
  "Africa/Casablanca": "+01:00",
  "Europe/Belfast": "+01:00",
  "Africa/Luanda": "+01:00",
  "Africa/Kinshasa": "+01:00",
  "Africa/Bangui": "+01:00",
  WET: "+01:00",
  "Africa/Niamey": "+01:00",
  GMT: "+00:00",
  "Atlantic/St_Helena": "+00:00",
  "Africa/Banjul": "+00:00",
  "Africa/Freetown": "+00:00",
  "Africa/Bamako": "+00:00",
  "Africa/Conakry": "+00:00",
  Universal: "+00:00",
  "Africa/Sao_Tome": "+00:00",
  "Africa/Nouakchott": "+00:00",
  UTC: "+00:00",
  "Etc/Universal": "+00:00",
  "Atlantic/Azores": "+00:00",
  "Africa/Abidjan": "+00:00",
  "Africa/Accra": "+00:00",
  "Etc/UCT": "+00:00",
  GMT0: "+00:00",
  Zulu: "+00:00",
  "Africa/Ouagadougou": "+00:00",
  "Atlantic/Reykjavik": "+00:00",
  "Etc/Zulu": "+00:00",
  Iceland: "+00:00",
  "Africa/Lome": "+00:00",
  Greenwich: "+00:00",
  "America/Danmarkshavn": "+00:00",
  "Africa/Dakar": "+00:00",
  "America/Scoresbysund": "+00:00",
  "Africa/Bissau": "+00:00",
  "Etc/Greenwich": "+00:00",
  "Africa/Timbuktu": "+00:00",
  UCT: "+00:00",
  "Africa/Monrovia": "+00:00",
  "Etc/UTC": "+00:00"
};

export const getTimeZoneData = () => {
  return timeZoneData;
};

export const getTimeZone = () => {
  return timeZone;
};
